var _circle, _rect, _rect2, _rect3, _rect4, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.943,
    cy: 15.5,
    r: 13.1143,
    stroke: "#404040",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.2715,
    width: 5.31429,
    height: 1.77143,
    transform: "rotate(90 17.2715 0)",
    fill: "#F1F0F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.2715,
    y: 25.6857,
    width: 5.31429,
    height: 1.77143,
    transform: "rotate(90 17.2715 25.6857)",
    fill: "#F1F0F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 14.1714,
    width: 5.31429,
    height: 1.77143,
    fill: "#F1F0F0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25.6857,
    y: 14.1714,
    width: 5.31429,
    height: 1.77143,
    fill: "#F1F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1573 9.74286L11.9573 15.5L18.1573 21.2571",
    stroke: "#404040",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.a9d3f5ef.svg";
export { ForwardRef as ReactComponent };